import consumer from '@/channels/consumer'
import { vuexConverter } from '@/utilities/vuex'

import { PERMISSIONS_NAMESPACE } from '../permissions'

const { mapAction } = vuexConverter(PERMISSIONS_NAMESPACE)

export const CHANNEL_NAMESPACE = 'PermissionsChannel'

export const PermissionsChannelActions = {
  UPDATED_USER: 'onServerUserUpdate',
  UPDATED_ROLE: mapAction('onServerRoleUpdate'),
}

export function PermissionsChannelPlugin (store) {
  consumer.subscriptions.create(CHANNEL_NAMESPACE, {
    received (command) {
      const { action, params } = command
      const storeAction = PermissionsChannelActions[action]

      if (!storeAction) return

      store.dispatch(storeAction, params)
    },
  })
}
